module.exports = __webpack_public_path__ + "static/media/display-area-tall.8088728a.png";